import {Component, Prop, Vue} from "vue-property-decorator";
import {Icon} from "~/components/icon";

@Component
class PageTitle extends Vue {

  @Prop({type: String, required:true}) title:string;
  @Prop({type: String, default: null}) icon:string;

  render() {
    return (
      <h1 class="page-title">
        {this.icon && <Icon icon={this.icon} />}
        <span>{this.title}</span>
      </h1>
    );
  }
}

export {PageTitle};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-79411f46/page-title.tsx" });